
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skipass",
      function () {
        return require("private-next-pages/[region]/[resort]/skipass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skipass"])
      });
    }
  